import React, { FC } from "react"

import { px, useMantineTheme } from "@mantine/core"
import { IconDatabase } from "@tabler/icons-react"

import ChartCard from "../../../analytics/components/chart-card/ChartCard"
import { useHealth } from "../../../../contexts/health-context"
import { useLanguage } from "../../../../contexts/language-context"
import formatBytes from "../../assets/formatBytes"

const DeviceStorageChart: FC = () => {
    const healthContext = useHealth()
    const health = healthContext.data.find(event => event.id === "latest")
    const { L } = useLanguage()
    const theme = useMantineTheme()
    let freeStorage = null
    let usedStorage = null
    if ([].concat(health?.storage).length == 1) {
        freeStorage = health?.storage ?? 50000000000
        usedStorage = 500000000000 - freeStorage
    } else {
        usedStorage = health?.storage[0]
        freeStorage = health?.storage[1]
    }

    return (
        <ChartCard
            label={L("Storage capacity")}
            option={{
                series: {
                    type: "pie",
                    name: L("Storage"),
                    radius: ["50%", "90%"],
                    top: px("1.5rem"),
                    bottom: px("1.5rem"),
                    itemStyle: {
                        borderRadius: px("0.5rem"),
                        borderColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[0],
                        borderWidth: 2,
                    },
                    label: {
                        color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
                        fontSize: theme.fontSizes.sm,
                        overflow: "break"
                    },
                    labelLine: {
                        show: true,
                        smooth: true,
                    },
                    emphasis: {
                        disabled: true
                    },
                    cursor: "default",
                    data: [
                        {
                            value: freeStorage,
                            name: `${L('Free')} (${formatBytes(freeStorage)})`,
                            itemStyle: {color: theme.fn.darken(theme.colors.green[2], 0.50) }
                        },
                        {
                            value: usedStorage,
                            name: `${L('Used')} (~${formatBytes(usedStorage, 0)})`,
                            itemStyle: {color:theme.fn.darken(theme.colors.orange[3], 0.45)}
                        }
                    ],
                }
            }}
            icon={IconDatabase}
        />
    )
}

export default DeviceStorageChart
